<h2 class="popup-heading" *ngIf="!errorMassage" mat-dialog-title>Set Primary Card</h2>
<mat-dialog-content class="mat-typography" *ngIf="!errorMassage">
    <div class="brands-view">
        <p>Are you sure you want to set this card ending in <strong>{{ paymentMethods[0].methods.last4 }}</strong> as your primary card?</p>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" *ngIf="!errorMassage">
    <button class="cancel-popup" mat-stroked-button (click)="Close()">Cancel</button>
    <button class="save" mat-flat-button (click)="cardDefault(paymentMethods)"
        [ngStyle]="{'background-color': 'var(--primary-color)', 'color': 'var(--light-color)'}" type="submit"
        [disabled]="processing">
        <mat-icon *ngIf="processing">
            <mat-spinner class="accent-spinner" diameter="20"></mat-spinner>
        </mat-icon>
        Save
    </button>
</mat-dialog-actions>
<div *ngIf="errorMassage">
    <h3 class="popup-heading">Billing Address Required</h3>
    <mat-dialog-content class="mat-typography">
        <span style="color: rgb(0,0,0);">{{ errorMassage }}</span>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button class="cancel-popup" mat-stroked-button (click)="Close()">Go to Billing</button>
    </mat-dialog-actions>
</div>